module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "min-height": "300"
    }
  }, [(_vm.loading) ? _c('v-card-text', [_c('center', [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "height": "2",
      "size": "70",
      "width": "2",
      "color": "amber"
    }
  }), _c('br'), _c('br'), _vm._v("\n    Loading\n    ")], 1)], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [
    [(_vm.clientId) ? _c('client-details', {
      attrs: {
        "value": _vm.client,
        "is-compact": _vm.$vuetify.breakpoint.xs
      }
    }) : (_vm.clientNotFound) ? _c('v-alert', {
      staticClass: "ma-0 py-0 caption lighten-1",
      attrs: {
        "value": true,
        "type": "info"
      }
    }, [_vm._v("\n        Unable to find the requested client.\n        "), _c('v-btn', {
      on: {
        "click": _vm.get
      }
    }, [_vm._v("Try again")]), _vm._v(" "), _c('v-btn', {
      on: {
        "click": function($event) {
          _vm.$store.dispatch('SET_SPACE', ['globalDialog', 'ClientList', 'Find a client', {
            showListInitially: true,
            withCreate: false,
            touch: Math.random()
          }, {
            clientselected: _vm.gotoClient
          }, _vm.$vuetify.breakpoint.xsOnly])
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-2"
    }, [_vm._v("search")]), _vm._v("\n          Search")], 1)], 1) : _vm._e()]
  ], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d3302b5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Client.vue
// module id = 1460
// module chunks = 9